import './Loader.css';
let Loader=(props)=>{ 
    if(props.msg){
        document.querySelector('.wheel').classList.toggle("act");

    } 
       

    return(
        <div className='processiogdiv'>
            <p style={{color:"green", width:"100%"}} className='msg'>{props.msg}</p>
            <div className='processingwheelcont'>
                <p className='wheel'></p>
            </div> 
        </div>
    );
}
export default Loader; 